import type {FileDocumentResponse} from "@mytour/shared";
import {useState} from "react";
import {useDocumentDownloadUrl} from "../query/documentQueries";
import {DocumentCardChrome} from "./DocumentCardChrome";
import {FileTileLightbox} from "./FileTileLightbox";

type Props = {
  docs: FileDocumentResponse[];
  onResume?: (document: FileDocumentResponse) => void;
};

export function PhotoCard({docs, onResume}: Props) {
  const first = docs[0];
  if (!first) {
    return null;
  }

  return (
    <DocumentCardChrome>
      <div className="d-flex flex-wrap gap-2">
        {docs.map((doc) => (
          <PhotoTile key={doc.id} doc={doc} onResume={onResume} />
        ))}
      </div>
    </DocumentCardChrome>
  );
}

function PhotoTile({
  doc,
  onResume,
}: {doc: FileDocumentResponse; onResume?: (document: FileDocumentResponse) => void}) {
  const available =
    !doc.uploadStatus || doc.uploadStatus === "legacy" || doc.uploadStatus === "received";
  const {downloadUrl} = useDocumentDownloadUrl(doc.id, available);
  const [open, setOpen] = useState(false);

  return (
    <FileTileLightbox
      doc={doc}
      onResume={onResume}
      previewUrl={downloadUrl ?? null}
      open={open}
      onToggle={() => setOpen((v) => !v)}
    />
  );
}
